
export const Types = {
    START_PUBLISH_CHALLENGE:              "START_PUBLISH_CHALLENGE",
    END_PUBLISH_CHALLENGE:                "END_PUBLISH_CHALLENGE",
    ERROR_PUBLISHING_CHALLENGE:           "ERROR_PUBLISHING_CHALLENGE",
    SHOW_PUBLISH_CHALLENGE_STATUS_MODAL:  "SHOW_PUBLISH_CHALLENGE_STATUS_MODAL",
    HIDE_PUBLISH_CHALLENGE_STATUS_MODAL:  "HIDE_PUBLISH_CHALLENGE_STATUS_MODAL",

    START_VALIDATE_CHALLENGE_ACTION:      "START_VALIDATE_CHALLENGE_ACTION",
    END_VALIDATE_CHALLENGE:               "END_VALIDATE_CHALLENGE",
    ERROR_VALIDATING_CHALLENGE:           "ERROR_VALIDATING_CHALLENGE",
    SHOW_VALIDATE_CHALLENGE_STATUS_MODAL: "SHOW_VALIDATE_CHALLENGE_STATUS_MODAL",
    HIDE_VALIDATE_CHALLENGE_STATUS_MODAL: "HIDE_VALIDATE_CHALLENGE_STATUS_MODAL",

    START_UNPUBLISH_CHALLENGE:             "START_UNPUBLISH_CHALLENGE",
    VERIFY_UNPUBLISH_CHALLENGE:            "VERIFY_UNPUBLISH_CHALLENGE",
    SUBMIT_UNPUBLISH_CHALLENGE:            "SUBMIT_UNPUBLISH_CHALLENGE",
    END_UNPUBLISH_CHALLENGE:               "END_UNPUBLISH_CHALLENGE",
    ERROR_UNPUBLISHING_CHALLENGE:          "ERROR_UNPUBLISHING_CHALLENGE",
    SHOW_UNPUBLISH_CHALLENGE_STATUS_MODAL: "SHOW_UNPUBLISH_CHALLENGE_STATUS_MODAL",
    HIDE_UNPUBLISH_CHALLENGE_STATUS_MODAL: "HIDE_UNPUBLISH_CHALLENGE_STATUS_MODAL"
};

/*
    Publish Actions
*/

export const startPublishChallengeAction = (challengeId, platforms, brk) => ({
    type: Types.START_PUBLISH_CHALLENGE,
    challengeId: challengeId,  // id of the challenge to publish
    platforms: platforms,
    brk: brk
});

export const endPublishChallengeAction = () => ({
    type: Types.END_PUBLISH_CHALLENGE
});

export const errorPublishingChallengeAction = (error) => ({
    type: Types.ERROR_PUBLISHING_CHALLENGE,
    error: error
});

export const showPublishChallengeStatusModalAction = ( successful, errors ) => ({
  type:             Types.SHOW_PUBLISH_CHALLENGE_STATUS_MODAL,
  validationErrors: errors,
  successful:        successful
});

export const hidePublishChallengeStatusModalAction = () => ({
  type: Types.HIDE_PUBLISH_CHALLENGE_STATUS_MODAL
});

/*
    Unpublish Actions
*/

export const startUnpublishChallengeAction = (challengeId, platforms, brk, challenge) => ({
    type: Types.START_UNPUBLISH_CHALLENGE,
    challengeId: challengeId,  // id of the challenge to publish
    challenge: challenge,
    platforms: platforms,
    brk: brk
});

export const verifyUnpublishChallengeAction = (challengeId, platforms, brk) => ({
    type: Types.VERIFY_UNPUBLISH_CHALLENGE
});

export const submitUnpublishChallengeAction = () => ({
    type: Types.SUBMIT_UNPUBLISH_CHALLENGE
});

export const endUnpublishChallengeAction = () => ({
    type: Types.END_UNPUBLISH_CHALLENGE
});

export const errorUnpublishingChallengeAction = (error) => ({
    type: Types.ERROR_UNPUBLISHING_CHALLENGE,
    error: error
});

export const showUnpublishChallengeStatusModalAction = ( successful, errors ) => ({
    type:             Types.SHOW_UNPUBLISH_CHALLENGE_STATUS_MODAL,
    validationErrors: errors,
    successful:        successful
});

export const hideUnpublishChallengeStatusModalAction = () => ({
    type: Types.HIDE_UNPUBLISH_CHALLENGE_STATUS_MODAL
});

/*
    Validate Actions
*/
export const startValidateChallengeAction = (challenge, platforms) => ({
  type: Types.START_VALIDATE_CHALLENGE_ACTION,
  challengeId: challenge.challengeId,
  platforms: platforms
});

export const endValidateChallengeAction = () => ({
  type: Types.END_VALIDATE_CHALLENGE
});

export const errorValidatingChallengeAction = (error) => ({
  type: Types.ERROR_VALIDATING_CHALLENGE
});

export const showValidateChallengeStatusModalAction = ( successful, errors ) => ({
  type:             Types.SHOW_VALIDATE_CHALLENGE_STATUS_MODAL,
  validationErrors: errors,
  successful: successful
});

export const hideValidateChallengeStatusModalAction = () => ({
  type: Types.HIDE_VALIDATE_CHALLENGE_STATUS_MODAL
});



// WEBPACK FOOTER //
// ./public/pages/BreakPublish/actions.js